<template>
    <detail-layout-full-width>
        <template slot="header">
            <BaseHeader :content="header" />
        </template>
        <template slot="main">
            <div class="form-wrapper">
                <el-form :model="form" :rules="rules" ref="ruleForm">
                  <div class="lg:max-w-detail lg:mr-auto">
                    <div class="mb-4">
                        <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.configuration_tbai.criteriocobrosypagos')}}</label>
                        <div class="flex flex-col md:flex-row">
                          <el-switch 
                            class="switch-text break-normal both-switch" 
                            v-model="form.CriterioCobrosYPagos" 
                            :disabled="isRoleUserOrConsulta"
                            :active-text="$t('app.active')" 
                            />
                        </div>
                    </div>
                    <div class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_tbai.tbaiconfig_regimen') }}</label>
                            <el-form-item prop="tipoRegimen">
                                <base-el-select class="w-full" v-model="form.tipoRegimen" :options="tiposRegimen" :disabled="isRoleUserOrConsulta" clearable filtrable />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_tbai.tbaiconfig_operacion') }}</label>
                            <el-form-item prop="tipoOperacion">
                                <base-el-select class="w-full" v-model="form.tipoOperacion" :options="tiposOperacion" :disabled="isRoleUserOrConsulta" clearable filtrable />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_tbai.tbaiconfig_no_exenta') }}</label>
                            <el-form-item prop="tipoNoExenta">
                                <base-el-select class="w-full" v-model="form.tipoNoExenta" :options="tiposNoExenta" :disabled="isRoleUserOrConsulta" clearable filtrable />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_tbai.tbaiconfig_no_sujeta') }}</label>
                            <el-form-item prop="tipoNoSujeta">
                                <base-el-select class="w-full" v-model="form.tipoNoSujeta" :options="tiposNoSujeta" :disabled="isRoleUserOrConsulta" clearable filtrable />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon />{{ $t('companies.configuration_tbai.hacienda') }}</label>
                            <el-form-item prop="tipoHacienda">
                                <base-el-select class="w-full" v-model="form.tipoHacienda" :options="tiposHacienda" :disabled=" !newAlta || isRoleUserOrConsulta" clearable filtrable />
                            </el-form-item>
                        </div>
                    </div>
                    <div class="lg:mb-2">
                        <div class="mandatory">
                            <label
                                class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('companies.configuration_tbai.epigrafe') }}</label>
                            <el-form-item prop="epigrafe">
                                <el-input class="w-full" v-model="form.epigrafe" :disabled="isRoleUserOrConsulta" clearable />
                            </el-form-item>
                        </div>
                    </div>
                  </div>
                </el-form>
            </div>
        </template>
        <template slot="layout-extend">
          <base-footer>
            <template slot="actions">
              <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
                :loading="isGeneralLoading" />
              <base-button-responsive mode="primary" :text="$t('app.save')" icon="check" @click="submitForm('ruleForm')"
                :loading="isGeneralLoading" :disabled="isGeneralLoading" />
            </template>
          </base-footer>
        </template>
    </detail-layout-full-width>
</template>
<script>
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import { getCompany } from '@/services/companies/getCompany'
import { getConfiguracionTBAI } from '@/services/configurations/getConfiguracionTBAI'
import { actualizarConfiguracionTBAI } from '@/services/configurations/actualizarConfiguracionTBAI'
import { agregarConfiguracionTBAI } from '@/services/configurations/agregarConfiguracionTBAI'
import { i18n } from '@/i18n'

export default {
  name: 'tbai-config',
  components: {
    DetailLayoutFullWidth
  },
  data () {
    return {
      header: {
        title: i18n.t('companies.configuration_tbai.tbaiconfig_header'),
        icon: 'companies',
        breadcrumb: {},
        url: 'companies/detail'
      },
      form: {
        idCIFEmpresa: '',
        tipoRegimen: '',
        tipoOperacion: '',
        tipoNoExenta: '',
        tipoNoSujeta: '',
        tipoHacienda: '',
        CriterioCobrosYPagos: false,
        epigrafe: ''
      },
      rules: {
        tipoRegimen: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoOperacion: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoNoExenta: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoNoSujeta: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        tipoHacienda: [
          {
            required: true,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
        ],
        epigrafe: [
          {
            max: 7,
            message: this.$i18n.t('validation.length_max', { maxLength: 7 }),
            trigger: 'blur'
          },
        ],
      },
      newAlta: false
    }
  },
  async mounted () {
    this.form.idCIFEmpresa = this.$route.params.id

    const breadcrumbs = []
    breadcrumbs.push({ path: 'companies', name: this.$i18n.t('companies.header') })

    if (this.$store.getters['app/fromRouteName'] !== null) {
      const breadcrumbHeader = this.$store.getters['app/headerBreadCrumb']
      breadcrumbs.push({ path: '', name: breadcrumbHeader })
    } else {
      const company = await this.getCompanyData(this.form.idCIFEmpresa)
      breadcrumbs.push({ path: '', name: company.RazonSocial })
      this.$store.commit('app/setheaderBreadCrumb', company.RazonSocial)
    }
    this.header.breadcrumb = breadcrumbs

    var res = await getConfiguracionTBAI({ idCIFEmpresa: this.form.idCIFEmpresa })
    if (!res.blnError) {
      this.setConfig(res.Respuesta)
    } else {
      this.doFeedback(`${res.msgError} [${res.codError}]`)
    }
  },
  methods: {
    getCompanyData: async function (idCIFEmpresa) {
      try {
        this.$store.commit('setIsLoading', true)

        const params = { idCIFEmpresa: idCIFEmpresa }
        const company = await getCompany(params)
        if (!company.blnError) {
          return company.CIFEmpresa
        }
        this.doFeedback(`${company.msgError} [${company.codError}]`)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return null
    },
    setConfig: function (data) {
      this.form.CriterioCobrosYPagos = data?.CriterioCobrosYPagos || false
      this.form.tipoRegimen = data?.ClaveRegimenEspecial || ''
      this.form.tipoOperacion = data?.TipoOperacionDefecto || ''
      this.form.tipoNoExenta = data?.TipoNoExentaDefecto || ''
      this.form.tipoNoSujeta = data?.TipoNoSujetaDefecto || ''
      this.form.tipoHacienda = data?.idHacienda.toString() || ''
      this.form.epigrafe = data?.Epigrafe || ''
      this.newAlta = !data?.idHacienda
    },
    submitForm: async function (formName) {
      setTimeout(() => {
        this.$store.commit('setIsLoading', true)
        this.$refs[formName].validate(async valid => {
          if (valid) {
            const data = {
              idCIFEmpresa: this.form.idCIFEmpresa,
              CriterioCobrosYPagos: this.form.CriterioCobrosYPagos,
              ClaveRegimenEspecial: this.form.tipoRegimen,
              TipoOperacionDefecto: this.form.tipoOperacion,
              TipoNoExentaDefecto: this.form.tipoNoExenta,
              TipoNoSujetaDefecto: this.form.tipoNoSujeta,
              idHacienda: this.form.tipoHacienda,
              Epigrafe: this.form.epigrafe,
            }
            var response = null
            if (this.newAlta) {
              response = await agregarConfiguracionTBAI(data, { idCIFEmpresa: this.form.idCIFEmpresa })
            } else {
              response = await actualizarConfiguracionTBAI(data, { idCIFEmpresa: this.form.idCIFEmpresa })
            }
            if (response && response.blnError === false && response.Respuesta) {
              this.doFeedback(i18n.t('feedback.success.saved_data_msg'), 'success')
            } else {
              this.doFeedback(`${response.msgError} [${response.codError}]`)
            }
            this.$store.commit('setIsLoading', false)
          } else {
            this.doFeedback(i18n.t('feedback.error.process_data_error'))
            this.$store.commit('setIsLoading', false)
            return false
          }
        })
      }, 100)
    },
    goBack: function () {
      this.$router.push({ name: this.header.url, params: { id: this.form.idCIFEmpresa } })
    }
  },
  computed: {
    role: function () {
      return this.$store.getters['auth/role']
    },
    isRoleUserOrConsulta: function () {
      return this.role === 1 || this.role === 4
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    tiposRegimen: function () {
      return this.$store.getters['config/TIPOS_TBAI_REGIMEN']
    },
    tiposOperacion: function () {
      return this.$store.getters['config/TIPOS_TBAI_OPERACION']
    },
    tiposNoExenta: function () {
      return this.$store.getters['config/TIPOS_TBAI_NO_EXENTA']
    },
    tiposNoSujeta: function () {
      return this.$store.getters['config/TIPOS_TBAI_NO_SUJETA']
    },
    tiposHacienda: function () {
      return this.$store.getters['config/TIPOS_HACIENDA']
    },
  }
}
</script>
